var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("game-collection " + _vm.viewType)},_vm._l((_vm.games),function(game,i){return _c('div',{key:i,staticClass:"gamelist-linewrap"},[_c('GameCollectionCard',{attrs:{"game":game,"viewType":_vm.viewType}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }